import { ProductDetailProps } from '@/types/general';
import classNames from 'classnames';
import InfoDescribed from '../InfoDescribed';
import style from './style.module.css';

type LayoutType = 'grid' | 'column';

interface InfoPainelsProps {
  infoTitle: string;
  data: ProductDetailProps[];
  layout?: LayoutType;
}

const InfoPainels = ({
  infoTitle,
  data,
  layout = 'column',
}: InfoPainelsProps) => {
  return (
    <div className={style.infoPainelsContainer}>
      <h4 className={style.infoPainelsTitle}>{infoTitle}</h4>
      <div className={classNames(style.contentInfoPainels, style[layout])}>
        {data.map((item, index) => (
          <div key={index} className={style.infoPainelsCard}>
            <InfoDescribed
              title={item.title}
              description={item.description}
              iconName={item.iconName}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoPainels;
